import ultravioletPrinting from "./templates/ultraviolet-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Практичный картхолдер красного или черного цвета 9,7 х 6,3 х 0,3 см. Поверхность идеально подходит для нанесения сложных цветовых изображений и фотографий. Краска наносится непосредственно на изделие. В результате мы получаем яркий и живой принт.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${ultravioletPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
